import { ALLOWED_FILE_LIMIT, ALLOWED_FILE_SIZE, INTERNALMESSAGES } from "../constants/messages";

export const formatFileSize = (sizeInBytes: number): string => {
    if (sizeInBytes < 1024) return `${sizeInBytes} B`;
    if (sizeInBytes < 1024 * 1024) return `${(sizeInBytes / 1024).toFixed(1)} KB`;
    return `${(sizeInBytes / 1024 / 1024).toFixed(2)} MB`;
}

export const updateTrailingNumber = (name: string, match: RegExpMatchArray | null, increment: boolean): string => {
    const baseName = name?.replace(/\s*\(\d+\)$/, '').trim();

    if (!increment) {
        return baseName;
    }

    const nextNumber = match ? parseInt(match[1], 10) + 1 : 2;

    return `${baseName} (${nextNumber})`;
}

export const validateAttachments = (
    newFiles: File[],
    currentAttachments: File[],
    maxSizeMB: number,
    maxFiles: number,
    allowedExtensions?: string[]
): string | null => {
    const oversized = newFiles.find(file => file.size > maxSizeMB * 1024 * 1024);
    if (oversized) {
        return ALLOWED_FILE_SIZE(maxSizeMB);
    }

    const combined = [...currentAttachments, ...newFiles];
    if (combined.length > maxFiles) {
        return ALLOWED_FILE_LIMIT(maxFiles);
    }

    if (allowedExtensions && allowedExtensions.length > 0) {
        const invalidFile = newFiles.find(file => {
            const ext = file.name.split('.').pop()?.toLowerCase();
            return !allowedExtensions.includes(ext);
        });

        if (invalidFile) {
            return INTERNALMESSAGES.INVALID_EXTENSIONS;
        }
    }

    return null;
};
